import {ReactNode} from "react";
import classNames from "classnames";

import {badgeBaseStyle} from "./Badge.module.css";
import {primaryBadgeStyle} from "./PrimaryBadge.module.css";

interface IProps {
    children: ReactNode;
    className?: string;
}

export const PrimaryBadge = (props: IProps) => {
    const primaryBadgeCN = classNames(badgeBaseStyle, primaryBadgeStyle, props.className);

    return <span className={primaryBadgeCN}>{props.children}</span>;
};
import {ReactNode} from "react";
import classNames from "classnames";

import {badgeBaseStyle} from "./Badge.module.css";
import {primaryBadgeStyle} from "./PrimaryBadge.module.css";

interface IProps {
    children: ReactNode;
    className?: string;
}

export const PrimaryBadge = (props: IProps) => {
    const primaryBadgeCN = classNames(badgeBaseStyle, primaryBadgeStyle, props.className);

    return <span className={primaryBadgeCN}>{props.children}</span>;
};
